import React from 'react';
import clsx from 'clsx';

interface SwitchProps {
	on: boolean;
	onChange: () => void;
	disabled?: boolean;
	label?: string;
}

export const Switch: React.FC<SwitchProps> = ({ on, onChange, disabled = false, label }) => {
	const handleToggle = () => {
		if (!disabled) {
			onChange();
		}
	};

	return (
		<div className="flex items-center">
			{label && (
				<button
					type="button"
					className={clsx(
						'text-sm font-medium text-900 duration-200 ease-in-out mr-3',
						disabled
							? 'text-gray-400 cursor-not-allowed'
							: 'text-gray-700 cursor-pointer'
					)}
					onClick={!disabled ? handleToggle : undefined}
				>
					{label}
				</button>
			)}

			<label
				className={clsx(
					'relative inline-flex flex-shrink-0 h-[20px] w-[38px] cursor-pointer rounded-full focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary-300',
					disabled && 'opacity-50 cursor-not-allowed',
					on ? 'bg-primary-500' : 'bg-gray-400'
				)}
			>
				<input
					type="checkbox"
					checked={on}
					onChange={handleToggle}
					disabled={disabled}
					className="sr-only"
					aria-label={label || 'Toggle'}
				/>

				<span
					className={clsx(
						'absolute top-[2px] left-[2px] size-[16px] bg-white rounded-full shadow-sm transition-transform ease-in-out duration-200 border-0',
						on ? 'translate-x-[18px]' : 'translate-x-0'
					)}
				/>
			</label>
		</div>
	);
};
